import type { Currency } from './currency.js';

export const ProjectConceptStatus = {
  New: 'new',
  Accepted: 'accepted',
  Rejected: 'rejected',
} as const;

export const ProjectConceptStatusValues = Object.values(ProjectConceptStatus);

export type ProjectConceptStatus = (typeof ProjectConceptStatus)[keyof typeof ProjectConceptStatus];

export const ProjectConceptPriority = {
  Low: 'low',
  Medium: 'medium',
  High: 'high',
} as const;

export const ProjectConceptPriorityValues = Object.values(ProjectConceptPriority);

export type ProjectConceptPriority = (typeof ProjectConceptPriority)[keyof typeof ProjectConceptPriority];

export const ProjectConceptOrigin = {
  User: 'USER',
  Governance: 'GOVERNANCE',
} as const;
export const ProjectConceptOriginValues = Object.values(ProjectConceptOrigin);
export type ProjectConceptOrigin = (typeof ProjectConceptOrigin)[keyof typeof ProjectConceptOrigin];

export interface ProjectConceptDto {
  id: string;
  title: string;
  budgetMin: number | null;
  budgetMax: number | null;
  budgetCurrency: Currency;
  expectedSavingsMin: number | null;
  expectedSavingsMax: number | null;
  expectedSavingsCurrency: Currency;
  priority: ProjectConceptPriority;
  department: string;
  status: ProjectConceptStatus;
  inquiryId: string | null;
  projectId: string | null;
  llmChatSessionId: string | null;
  origin: ProjectConceptOrigin;
  createdAt: string;
  updatedAt: string;
}

export interface CreateProjectConceptDto {
  title: string;
  budgetMin?: number;
  budgetMax?: number;
  budgetCurrency?: string;
  expectedSavingsMin?: number;
  expectedSavingsMax?: number;
  expectedSavingsCurrency?: string;
  priority: ProjectConceptPriority;
  department: string;
  /** Links the originating chat session to this concept after create. */
  chatSessionId?: string;
  /** Links this concept back to the decision case after create. */
  decisionCaseId?: string;
}

export interface UpdateProjectConceptDto extends Partial<CreateProjectConceptDto> {
  status?: ProjectConceptStatus;
  inquiryId?: string;
}
